import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    addCustomer,
    deleteCustomer,
    fillCustomers,
    getCustomers,
    getCustomersCreation,
    initAddCustomerAsyncState,
    removeAllFilters,
    selectCustomers,
    selectCustomersObjs,
    selectGetCustomersAsyncState, selectPriceMenus
} from 'store/customers/customersSlice';

// locale
import {FormattedMessage} from 'react-intl';
import {useTheme} from '@mui/material/styles';

// project imports
import AddCustomer from './AddCustomer';
import Loader from 'ui-component/Loader';

// types
import {HeadCell} from 'types';
import {
    AppBar,
    Avatar,
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Slide,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@mui/material';
import {callbackNetworkResult, fetchMimshakClient, getFile} from '../../api/customer/files.api';
import {buildClientsImportAdapter} from '../../api/customer/importClientsAdapter';
import {ImportWizardTrigger} from 'ui-component/import-wizard';
import {TransitionProps} from '@mui/material/transitions';
import {cloneDeep} from 'lodash';
import AgTable, {getSelectedRows, ITableControls} from 'ui-component/ag-grid/Ag-Table';
import {IconEdit, IconId, IconInfoCircle, IconPhone, IconTrash} from '@tabler/icons';
import MyChip from 'ui-component/extended/Chip';
import PeopleIcon from '@mui/icons-material/People';
import {Mail, MapPin, User} from 'tabler-icons-react';
import Swal from 'sweetalert2';
import CustomerPreview from './profile/documents/CustomerPreview';
import CloseIcon from '@mui/icons-material/Close';
import CustomerStatus from './properties/CustomerStatus';
import dayjs from 'dayjs';
import {getAgents, selectDrivers, selectLines} from "../../store/agents/agentsSlice";
import Agent from "../../types/agent";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AgTableContainer from 'ui-component/ag-grid/table-container';
import {changeAllCustomers} from "../../api/customer";
import CreateBranchDialog from './CreateBranchDialog';
import {
    customGroup,
    customGroupActiveForChip,
    customGroupLabelForChip,
    rowGroupRenderer
} from 'ui-component/ag-grid/ag-table-utils';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import JSDB from 'fromKotlin/nk';
import {dateObjectToString, dateObjectToStringIsrael} from 'fromKotlin/nkutils';
import {appendCofcOrderShopLink, encodeWhatsappShareText} from '../../utils/whatsappShareUrl';
import {buildNotesSum, buildSupNotesSum, getCofcLink, getCofcReturnLink} from 'api/customer/documents.api';
import {createClientEditLink} from 'api/customer/externalLinks.api';
import {getRepLinkFlags} from 'utils/repLinkFlags';
import {whatsapp} from 'assets/images';
import {ContentCopy, EmailOutlined, Link as LinkIcon, NoteAdd, PriceChangeOutlined, Send, WhatsApp} from '@mui/icons-material';
import {makeCustomer} from 'types/customer';
import SendMessageDialog from 'ui-component/dialogs/sendMessage';
import {distinctByField} from "../../utils/sort";
import {docColumns} from "./profile/documents/Table";
import {GenerativeLoaderChip, GenerativeLoaderChipSum} from "../../ui-component/GenerativeLoader";
import FunctionsOutlinedIcon from "@mui/icons-material/FunctionsOutlined";
import {SNACKBAR_OPEN} from 'store/actions';

/** Price menus are clients with id ≤ -10. Next id is the smallest existing in that range, minus 1 (first is -10). */
const nextPriceMenuClientId = (customers: { id?: string | number }[] = []): number => {
    let minNeg: number | null = null;
    const consider = (raw: unknown) => {
        const id = Number(raw);
        if (!Number.isFinite(id) || id > -10) return;
        if (minNeg === null || id < minNeg) minNeg = id;
    };
    try {
        const fromDb = JSDB().getAllClient(false)?.first?.toArray?.() ?? [];
        fromDb.forEach((c) => consider(c?.id));
    } catch {
        // fall through to the redux list
    }
    customers.forEach((c) => consider(c?.id));
    return (minNeg ?? -9) - 1;
};

export const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const headCells: HeadCell[] = [
        {
            id: 'actions',
            numeric: false,
            label: 'פעולות',
            align: 'center',
            filterable: false,
            sortable: false,
            pinned: 'left',
            cellRenderer: ({params, setCostumerDetails, setPreviewOpen, setCustomerAction, theme, dispatch, setWhatsAppDialog}) => {
                const rowData = params?.data;
                if (params?.node?.group) return params?.value || '';
                return (
                    <>
                        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                            <Tooltip title={<FormattedMessage id='customer-profile'/>}>
                                <IconButton onClick={() => {
                                    setCostumerDetails({
                                        name: params?.data?.name,
                                        id: params?.data?.id
                                    });
                                    setPreviewOpen(true)
                                }} size='small'>
                                    <IconId fontSize='small'/>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={<FormattedMessage id='edit'/>}>
                                <IconButton
                                    onClick={() => {
                                        setCustomerAction({editable: true, open: true, id: params?.data?.id})
                                        setCostumerDetails({
                                            name: params?.data?.name,
                                            id: params?.data?.id
                                        });
                                    }}
                                    size='small'>
                                    <IconEdit size={21} strokeWidth={2} color={theme?.palette?.primary?.main}/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title='שלח בווטסאפ לביצוע הזמנה'>
                                <IconButton size='small' onClick={() => {
                                    setWhatsAppDialog({open: true, rowData});
                                }}>
                                    <Avatar variant='square'
                                            sx={{cursor: 'pointer', bgcolor: 'white', width: '18px', height: '18px'}}
                                            src={whatsapp}/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={params?.data?.active ? 'מחיקת לקוח' : 'להחזיר לקוח'}>
                                <IconButton
                                    size='small'
                                    onClick={() =>
                                        Swal.fire({
                                            title: params?.data?.active ? 'האם תרצה למחוק לקוח?' : 'האם תרצה להחזיר לקוח',
                                            text: '',
                                            icon: 'warning',
                                            showCancelButton: true,
                                            confirmButtonColor: theme?.palette?.primary?.dark,
                                            cancelButtonColor: theme?.palette?.error?.light,
                                            confirmButtonText: params?.data?.active ? 'מחק לקוח' : 'החזר לקוח',
                                            cancelButtonText: 'בטל'
                                        }).then((result) => {
                                            if (result?.isConfirmed) {
                                                dispatch(deleteCustomer({
                                                    id: Number(params?.data?.id),
                                                    active: !(params?.data?.active)
                                                }));
                                            }
                                        })
                                    }
                                >
                                    {params?.data?.active ?
                                        <IconTrash size={20} strokeWidth={2} color={theme?.palette?.error?.main}/> :
                                        <RestartAltIcon strokeWidth={2} color={"success"}/>}
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </>
                )
            },
        },
        {
            id: 'id',
            numeric: false,
            label: 'מזהה',
            align: 'center'
        },
        {
            id: 'status',
            numeric: false,
            label: 'סטטוס',
            hide: true,
            enableRowGroup: true,
            align: 'center',
            cellRenderer: ({params}) => {
                return <CustomerStatus customer={params?.data}/>
            }
        },
        {
            id: 'name',
            numeric: false,
            label: 'שם לקוח',
            align: 'center',
            extendedSearchProperties: ['name', 'businessName', 'id', 'externalId'],
            searchQueryPlaceholder: 'שם / מזהה / טלפון / מייל',
            cellRenderer({params, setCostumerDetails, setPreviewOpen}) {
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: 'pointer',
                    }}
                         onClick={() => {
                             setCostumerDetails({
                                 name: params?.data?.name,
                                 id: params?.data?.id
                             });
                             setPreviewOpen(true)
                         }}
                    >
                        <Typography color={'blue'} variant='h5'>{params?.data?.name}</Typography>
                        {params?.data?.noTaxClient ? (
                            <MyChip label="ללא מע''מ" chipcolor='orange' size='small'/>
                        ) : undefined}
                    </div>
                )
            },
        },
        {
            id: 'businessName',
            numeric: false,
            label: 'פרטי עסק',
            align: 'center',
            extendedSearchProperties: ['businessName', 'businessId'],
            searchQueryPlaceholder: 'שם/ע.מ/ח.פ',
            enableRowGroup: true,
            editable: true,
            cellRenderer: ({params}) => {
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        {(params?.data?.nkObject?.branch ?? -1) >= 0 ? <PeopleIcon
                            style={{color: params?.data?.nkObject?.master === -1 ? 'blue' : undefined}}/> : undefined}
                        <Typography variant='h5'>{params?.data?.businessName}</Typography>
                        {params?.data?.businessId ? (
                            <Typography variant='caption'>
                                {params?.data?.businessId} <br/>
                            </Typography>
                        ) : undefined}
                    </div>
                )
            }
        },
        {
            id: 'businessId',
            numeric: false,
            label: 'ח.פ/ע.מ',
            align: 'center',
            hide: false,
            extendedSearchProperties: ['businessName', 'businessId'],
            searchQueryPlaceholder: 'שם/ע.מ/ח.פ',
            enableRowGroup: true,
            editable: true,
        },
        {
            id: "position",
            label: "סדר",
            numeric: false,
            priority: -1,
            hide: true,
            editable: true,
        },
        {
            id: 'branch',
            numeric: false,
            label: 'רשת',
            hide: true,
            align: 'center',
            cellRenderer: ({params}) => {
                if (params?.node?.group) {
                    return params?.value || "";
                }
                const client = JSDB().getClient(Number(params?.data?.id))?.first;
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Typography style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                        }} variant='h5'>
                            {(params?.data?.nkObject?.branch ?? -1) >= 0 ?
                                <PeopleIcon style={{
                                    color: params?.data?.nkObject?.master === -1 ? 'blue' :
                                        undefined
                                }}
                                /> :
                                undefined}
                            {client?.getNetworkBusinessName?.() ?? client?.getBusinessName()}
                        </Typography>
                        <Typography
                            variant='h5'>{(params?.data?.nkObject?.branch ?? -1) >= 0 ? params?.data?.nkObject?.master === -1 ? "סניף מרכזי" : "רשת" : 'פרטי'}
                        </Typography>
                    </div>
                )
            },
            extractFunc: (data) => {
                const client = JSDB().getClient(Number(data?.id))?.first;
                const branch = client?.branch
                if (branch && branch != -1) {
                    // The master's name, so grouping by רשת keeps a network together even when
                    // its branches each bill under their own שם עוסק.
                    return client?.getNetworkBusinessName?.() ?? client?.getBusinessName()
                }
                return 'פרטי'
            }
        },
        {
            id: "category",
            label: "קטגורית לקוחות",
            numeric: false,
            priority: -1,
            hide: true,
            editable: true,
        },
        {
            id: "group",
            label: "קבוצת לקוחות",
            numeric: false,
            priority: -1,
            hide: true,
            editable: true,
        },
        {
            id: "comments",
            label: "הערות",
            numeric: false,
            priority: -1,
            hide: true,
            cellEditor: 'agLargeTextCellEditor',
            editable: true,
        },


        {
            id: "days_to_pay",
            label: "שוטף לתשלום",
            numeric: true,
            editable: true,
            priority: -1,
            hide: true,
        },

        {
            id: "email",
            label: "מייל",
            numeric: false,
            priority: -1,
            hide: true,
            editable: true,
            cellRenderer: ({params}) => {
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: 'pointer',
                    }}
                         onClick={() => window.open(`mailto:${params?.data?.email}`, '_blank')?.focus()}
                    >
                        {params?.data?.email && <Typography variant="subtitle1">
                            {' '}
                            <Mail size={14} strokeWidth={1} color="#000000"/> {params?.data?.email}
                        </Typography>}
                    </div>
                )
            }
        },

        {
            id: 'contactName',
            numeric: false,
            label: 'איש קשר',
            align: 'center',
            hide: true,
            editable: true,
        },
        {
            id: 'contactName2',
            numeric: false,
            label: 'איש קשר 2',
            align: 'center',
            hide: true,
            editable: true,
        },
        {
            id: 'includeTax',
            numeric: false,
            label: 'כולל מעמ',
            align: 'center',
            hide: true,
            extractFunc: (row) => {
                return row?.includeTax ? 'כן' : 'לא'
            },
            editable: true,
        },
    {
            id: 'last_visit',
            numeric: false,
            label: 'ביקור אחרון',
            align: 'center',
            hide: true,
        type: 'dateStr', filterable: true,
            extractFunc: (row) => {
                return row?.nkObject?.lastVisit ? JSDB().getDatesManipulator().dateIsrael(row?.nkObject?.lastVisit) : ''
            },

        },
    {
            id: 'priceControl',
            numeric: false,
            label: 'מחירון',
            align: 'center',
            hide: true,
        cellRenderer: ({params,priceMenus}) => {

            const menu = priceMenus.find((s) => s.id == Number(params?.data?.priceControl))
            if(!menu) return ''
            return <div> {menu?.name} </div>


        },
            editable: false,
        },
        {
            id: 'agent',
            numeric: false,
            label: 'שם קו',
            align: 'center',
            searchQueryPlaceholder: 'שם קו/קטגוריה',
            extendedSearchProperties: ['agent', 'category'],
            enableRowGroup: true,
            editable: true,
            // cellRenderer: ({ params, column, menuItems }) => {
            //     !menuItems?.[column?.id]?.includes(params?.data?.agent) && menuItems?.[column?.id]?.push(params?.data?.agent)
            //     return (
            //         <div style={{
            //             display: 'flex',
            //             flexDirection: 'column',
            //         }}>
            //             <Typography variant='h5'>{params?.data?.agent}</Typography>
            //             {(params?.data?.category != '') ? <Typography variant="caption">
            //                 {params?.data?.category}
            //             </Typography> : undefined}
            //         </div>
            //     )
            // }
        },
        {
            id: 'driver',
            numeric: false,
            label: 'נהג',
            align: 'center',
            // aggFunc:(params) => {
            //     return params.values[0]
            // },
            searchQueryPlaceholder: 'נהג/מלקט',
            extendedSearchProperties: ['driver', 'collector'],
            enableRowGroup: true,
            editable: true,
            // cellRenderer: ({ params }) => {
            //     return (
            //         <div style={{
            //             display: 'flex',
            //             flexDirection: 'column',
            //         }}>
            //             {(params?.data?.driver) ? <Typography variant='h5'>{params?.data?.driver}</Typography> : undefined}
            //             {(params?.data?.collector) ? <Typography variant='h5'>{params?.data?.collector}</Typography> : undefined}
            //         </div>
            //     )
            // }
        },
        {
            id: 'noteType',
            numeric: false,
            label: 'סוג תעודה',
            align: 'center',
            hide: true,
            enableRowGroup: true,
            extractFunc: (row) => {
                if (row?.visit) return 'תעודת ביקור';
                if (row?.notes) return 'תעודת משלוח';
                return 'חשבונית';
            },
            cellRenderer: ({params}) => {
                if (params?.node?.group) return params?.value || '';
                if (params?.data?.visit) {
                    return <MyChip label="תעודת ביקור" chipcolor="secondary" size="small"/>;
                }
                if (params?.data?.notes) {
                    return <MyChip label="תעודת משלוח" chipcolor="success" size="small"/>;
                }
                return <MyChip label="חשבונית" chipcolor="primary" size="small"/>;
            },
        },
        {
            id: 'collector',
            numeric: false,
            label: 'מלקט',
            hide: true,
            align: 'center',
            // cellRenderer: ({ params }) => {
            //     return (
            //         <div style={{
            //             display: 'flex',
            //             flexDirection: 'column',
            //         }}>
            //             {(params?.data?.driver) ? <Typography variant='h5'>{params?.data?.driver}</Typography> : undefined}
            //             {(params?.data?.collector) ? <Typography variant='h5'>{params?.data?.collector}</Typography> : undefined}
            //         </div>
            //     )
            // }
        },

        {
            id: 'addressSummary',
            numeric: false,
            label: 'כתובת',
            align: 'center',
            extendedSearchProperties: ['city', 'street', 'streetNumber'],
            searchQueryPlaceholder: 'עיר/כתובת',
            enableRowGroup: false,
            editable: false,
            extractFunc: (row) => {
                const address =
                    row?.street && row?.streetNumber
                        ? `${row.street}, ${row.streetNumber}`
                        : row?.street;
                if (row?.city && address) return `${address} ${row.city}`;
                return row?.city || address || '';
            },
            cellRenderer: ({params}) => {
                const address =
                    params?.data?.street && params?.data?.streetNumber
                        ? `${params?.data?.street}, ${params?.data?.streetNumber}`
                        : params?.data?.street;
                const full_address =
                    params?.data?.city && address ? `${address} ${params?.data?.city}` : params?.data?.city;
                const openGmaps = (result) => {
                    window?.open(`https://www.google.com/maps/search/?api=1&query=${result}`, '_blank')?.focus();
                };
                if (params?.node?.group) return params?.value || '';
                return (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            cursor: 'pointer',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            openGmaps(
                                params?.data?.location != '' ? params?.data?.location : full_address
                            );
                        }}
                    >
                        {!params?.data?.city && !address && params?.data?.location == '' ? (
                            <div />
                        ) : (
                            <>
                                <Typography variant="subtitle1">
                                    {' '}
                                    <MapPin size={14} strokeWidth={1} color="#000000" /> {params?.data?.city}
                                </Typography>
                                <Typography variant="caption">{address}</Typography>
                            </>
                        )}
                    </div>
                );
            },
        },
        {
            id: 'street',
            numeric: false,
            label: 'רחוב',
            align: 'center',
            hide: true,
            editable: true,
        },
        {
            id: 'streetNumber',
            numeric: false,
            label: 'מספר בית',
            align: 'center',
            hide: true,
            editable: true,
        },
        {
            id: 'city',
            numeric: false,
            label: 'עיר',
            align: 'center',
            hide: true,
            enableRowGroup: true,
            editable: true,
            extractFunc: (row) => row?.city,
        },
        {
            id: "location",
            label: "מיקום",
            hide: true,
            numeric: false,
            editable:true,
            priority: -1,
            cellRenderer: ({params}) => {
                const openGmaps = (result) => {
                    window.open(`https://www.google.com/maps/search/?api=1&query=${result}`, '_blank')?.focus();
                };
                return (
                    <div style={{
                        display: 'flex',
                        cursor: 'pointer',
                        alignItems: "center",
                    }}
                         onClick={() => openGmaps(params?.data?.location)}
                    >
                        {params?.data?.location != "" && <><MapPin size={14} strokeWidth={1} color="#000000"/>
                            <div><Typography variant="caption">{params?.data?.location}</Typography></div>
                        </>}
                    </div>
                )
            }
        },
        {
            id: 'externalId',
            numeric: false,
            label: 'מזהה חיצוני',
            align: 'center',
            type:'numOrStr',
            extendedSearchProperties: ['externalId'],
            searchQueryPlaceholder: 'מזהה חיצוני',
            editable: true,
        },
    {
        id: 'nameEnglish',
        numeric: false,
        label: 'שם באנגלית',
        align: 'center',
        hide: true,
        extendedSearchProperties: ['externalId'],
        editable: true,
    },   {
        id: 'addressEnglish',
        numeric: false,
        label: 'כתובת באנגלית',
        align: 'center',
        hide: true,
        extendedSearchProperties: ['externalId'],

        editable: true,
    },
        {
            id: 'date',
            type: 'date_range',
            numeric: false,
            hide: true,
            hideForce: true,
            label: 'תאריך יצירה',
            align: 'center',
            searchQueryPlaceholder: 'תאריך',
            priority: -1,
            disableCheckbox: true,
        },
        {
            id: 'obligo',
            numeric: false,
            label: 'אובליגו',
            align: 'center',
            hide: true,
            editable: true,
        },
    {
        id: 'min_order',
        numeric: true,
        label: 'מינמום הזמנה',
        align: 'center',
        hide: true,
        editable: true,
    },    {
        id: 'min_order_sum',
        numeric: true,
        label: 'מינמום הזמנה בכסף',
        align: 'center',
        hide: true,
        editable: true,
    },
        {
            id: 'discount',
            numeric: false,
            label: 'הנחה',
            align: 'center',
            hide: true,
            editable: true,
            valueSetter: (data, newValue) => {
                const n = Number(newValue);
                data.discount = Number.isFinite(n) ? Math.min(n, 100) : newValue;
                return data;
            },
        },
        {
            id: 'net_edi',
            label: 'EDI Net',
            numeric: false,
            hide: true,
            editable: (params) => true,
        },
        {
            id: 'branch_number',
            label: 'EDI Branch',
            numeric: false,
            hide: true,
            editable: (params) => true,

        },
        {
            id: 'edi_client_id',
            label: 'EDI Number',
            numeric: false,
            hide: true,
            editable: (params) => true,
        },
        {
            id: 'internal_sup_edi',
            label: 'net Sup ID',
            numeric: false,
            hide: true,
            editable: (params) => true,
        },
        {
            id: 'edi_sup_id',
            label: 'edi Sup ID',
            numeric: false,
            hide: true,
            editable: (params) => true,
        },
        {
            id: 'action_time',
            numeric: false,
            label: 'עדכון אחרון',
            hide: true,
            align: 'center',
            editable: (params) => true,
        },

        {
            id: 'sunday',
            numeric: false,
            label: 'יום א',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },
        },
        {
            id: 'monday',
            numeric: false,
            label: 'יום ב',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },
        },
        {
            id: 'tuesday',
            numeric: false,
            label: 'יום ג',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },
        },
        {
            id: 'wednesday',
            numeric: false,
            label: 'יום ד',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },
        },
        {
            id: 'thursday',
            numeric: false,
            label: 'יום ה',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },
        },
        {
            id: 'friday',
            numeric: false,
            label: 'יום ו',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },

        },
        {
            id: 'saturday',
            numeric: false,
            label: 'יום ש',
            hide: true,
            align: 'center',
            editable: true,
            cellRenderer({params}) {
                if (params?.node?.group) {
                    return '';
                }
                return params?.value ? 'כן' : 'לא';
            },
        },
    ]
;


const WhatsAppLinkDialog = ({open, rowData, onClose}: {open: boolean, rowData: any, onClose: () => void}) => {
    const [linkType, setLinkType] = React.useState<'regular' | 'returns'>('regular');
    const [generatedLink, setGeneratedLink] = React.useState<string>('');
    const [loading, setLoading] = React.useState(false);
    const [copied, setCopied] = React.useState(false);
    const date = React.useMemo(() => new Date(), [open]);

    const buildWhatsappUrl = React.useCallback((pass: string) => {
        const client = JSDB().getClient(Number(rowData?.id))?.first;
        let text = JSDB().userCofcConf?.text && JSDB().userCofcConf?.text != "None"
            ? JSDB().userCofcConf?.text
            : `שלום ${"#name"} ${"#id"}אנא בצע הזמנה עבור ${JSDB().getUser().first.user_company_print_name}`;
        text = text.replace("#name", client.getName());
        text = text.replace("#id", client.id);
        text = text.replace("#external_id", client.getExternalId());
        text = text.replace("#date", dateObjectToStringIsrael(date));
        text = text.replace("#day", JSDB().getDatesManipulator().getDayOfWeekStr(dateObjectToString(date), true));
        return appendCofcOrderShopLink(text, pass, dateObjectToString(date), {
            returns: linkType === 'returns',
        });
    }, [rowData, date,linkType]);

    React.useEffect(() => {
        if (!open || !rowData) return;
        setGeneratedLink('');
        setCopied(false);
        setLoading(true);
        const apiFn = linkType === 'regular'
            ? () => getCofcLink(Number(rowData.id), date)
            : () => getCofcReturnLink(Number(rowData.id), date);
        apiFn()
            .then((pass) => {
                const url = buildWhatsappUrl(pass);
                setGeneratedLink(url);
            })
            .catch(() => setGeneratedLink(''))
            .finally(() => setLoading(false));
    }, [open, rowData, linkType]);

    const handleSendWhatsapp = () => {
        const client = JSDB().getClient(Number(rowData?.id))?.first;
        const phone = client?.getPhone();
        window?.open(`https://api.whatsapp.com/send?text=${encodeWhatsappShareText(generatedLink)}&phone=${JSDB().getValidPhone(phone)}`, '_blank')?.focus();
        onClose();
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(generatedLink).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <Avatar variant="square" sx={{bgcolor: 'white', width: 28, height: 28}} src={whatsapp}/>
                שליחת קישור בווטסאפ
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="subtitle2" gutterBottom>בחר סוג קישור:</Typography>
                <RadioGroup
                    row
                    value={linkType}
                    onChange={(e) => setLinkType(e.target.value as 'regular' | 'returns')}
                    sx={{mb: 2}}
                >
                    <FormControlLabel value="regular" control={<Radio/>} label="קישור רגיל (הזמנה)"/>
                    <FormControlLabel value="returns" control={<Radio/>} label="קישור החזרות"/>
                </RadioGroup>
                {loading ? (
                    <Box sx={{display: 'flex', justifyContent: 'center', py: 2}}>
                        <CircularProgress size={28}/>
                    </Box>
                ) : (
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="הקישור שנוצר"
                        value={generatedLink || ''}
                        InputProps={{
                            readOnly: true,
                            endAdornment: generatedLink ? (
                                <InputAdornment position="end">
                                    <Tooltip title={copied ? 'הועתק!' : 'העתק'}>
                                        <IconButton size="small" onClick={handleCopy}>
                                            <ContentCopy fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) : undefined,
                        }}
                        variant="outlined"
                        size="small"
                    />
                )}
            </DialogContent>
            <DialogActions sx={{gap: 1, px: 3, pb: 2}}>
                <Button variant="outlined" onClick={onClose}>ביטול</Button>
                <Button
                    variant="outlined"
                    startIcon={<ContentCopy/>}
                    disabled={!generatedLink || loading}
                    onClick={handleCopy}
                >
                    {copied ? 'הועתק!' : 'העתק קישור'}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Send/>}
                    disabled={!generatedLink || loading}
                    onClick={handleSendWhatsapp}
                    sx={{bgcolor: '#25D366', '&:hover': {bgcolor: '#1da851'}}}
                >
                    שלח בווטסאפ
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const ClientEditLinkDialog = ({open, rowData, onClose}: {open: boolean, rowData: any, onClose: () => void}) => {
    const [link, setLink] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [copied, setCopied] = React.useState(false);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!open || !rowData?.id) return;
        setLink('');
        setCopied(false);
        setLoading(true);
        createClientEditLink(Number(rowData.id))
            .then(setLink)
            .catch(() => {
                setLink('');
                dispatch({
                    type: SNACKBAR_OPEN,
                    open: true,
                    message: 'יצירת לינק עדכון נכשלה',
                    variant: 'alert',
                    alertSeverity: 'error',
                });
            })
            .finally(() => setLoading(false));
    }, [open, rowData, dispatch]);

    const handleCopy = () => {
        if (!link) return;
        navigator.clipboard.writeText(link).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const handleSendWhatsapp = () => {
        const client = JSDB().getClient(Number(rowData?.id))?.first;
        const phone = client?.getPhone();
        const name = client?.getName?.() || rowData?.name || '';
        const text = `שלום ${name},\nנא לעדכן את הפרטים ולחתום על המסמכים בקישור:\n${link}`;
        window?.open(
            `https://api.whatsapp.com/send?text=${encodeWhatsappShareText(text)}&phone=${JSDB().getValidPhone(phone)}`,
            '_blank',
        )?.focus();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <LinkIcon fontSize="small" />
                לינק עדכון פרטים ומסמכים
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                    לינק חד-פעמי לשעה. הלקוח מעדכן פרטים ומעלה מסמכים לכרטיס שלו.
                </Typography>
                {loading ? (
                    <Box sx={{display: 'flex', justifyContent: 'center', py: 2}}>
                        <CircularProgress size={28}/>
                    </Box>
                ) : (
                    <TextField
                        fullWidth
                        multiline
                        rows={2}
                        label="הקישור שנוצר"
                        value={link || ''}
                        InputProps={{
                            readOnly: true,
                            endAdornment: link ? (
                                <InputAdornment position="end">
                                    <Tooltip title={copied ? 'הועתק!' : 'העתק'}>
                                        <IconButton size="small" onClick={handleCopy}>
                                            <ContentCopy fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) : undefined,
                        }}
                        variant="outlined"
                        size="small"
                        inputProps={{dir: 'ltr'}}
                    />
                )}
            </DialogContent>
            <DialogActions sx={{gap: 1, px: 3, pb: 2}}>
                <Button variant="outlined" onClick={onClose}>ביטול</Button>
                <Button
                    variant="outlined"
                    startIcon={<ContentCopy/>}
                    disabled={!link || loading}
                    onClick={handleCopy}
                >
                    {copied ? 'הועתק!' : 'העתק קישור'}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Send/>}
                    disabled={!link || loading}
                    onClick={handleSendWhatsapp}
                    sx={{bgcolor: '#25D366', '&:hover': {bgcolor: '#1da851'}}}
                >
                    שלח בווטסאפ
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const CustomerList = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const agent: Agent[] = useSelector(selectLines);
    const drivers = useSelector(selectDrivers);

    const asyncState = useSelector(selectGetCustomersAsyncState);
    const [state, setColumnState] = React.useState(undefined);
    const [displayActive, setDisplayActive] = React.useState<boolean>(true);
    const customers = useSelector(state => selectCustomersObjs(state, displayActive));
    const allCustomersForXlsx = useSelector(selectCustomers);
    const allCustomersXlsxRef = React.useRef(allCustomersForXlsx);
    allCustomersXlsxRef.current = allCustomersForXlsx;
    const [cols, setCols] = React.useState<HeadCell[]>(headCells);
    const priceMenus = useSelector(state => selectPriceMenus(state));
    React.useEffect(() => {
        const newCols = cloneDeep((cols))

        const phone1 = JSDB().getUser().first?.getJsonDesc("cphone1")
        let labelPhone1 = "טלפון";
        if (phone1) {
            labelPhone1 = phone1.name;
        }
        newCols.push(   {
            id: "phone",
            label: labelPhone1,
            numeric: false,
            editable: true,
            priority: -1,
            cellRenderer: ({params}) => {
                const openPhone = (result) => {
                    window.open(`tel:${result}`, '_blank')?.focus();
                };
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    >
                        {params?.data?.phone && <Typography variant="subtitle1" style={{cursor: "pointer"}}
                                                            onClick={() => openPhone(params?.data?.phone)}>
                            <IconPhone size={12} strokeWidth={1} color='#000000'/> {params?.data?.phone}
                        </Typography>}
                    </div>
                )
            }
        }  )

        const phone2 = JSDB().getUser().first?.getJsonDesc("cphone2")
        let labelPhone2 = "טלפון 2";
        if (phone2) {
            labelPhone2 = phone2.name;
        }
        newCols.push( {
            id: "phone2",
            label: labelPhone2,
            numeric: false,
            hide: true,
            priority: -1,
            editable: true,
            cellRenderer: ({params}) => {
                const openPhone = (result) => {
                    window.open(`tel:${result}`, '_blank')?.focus();
                };
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    >
                        {params?.data?.phone2 && <Typography variant="subtitle1" style={{cursor: "pointer"}}
                                                             onClick={() => openPhone(params?.data?.phone2)}>
                            <IconPhone size={12} strokeWidth={1} color='#000000'/> {params?.data?.phone2}
                        </Typography>}
                    </div>
                )
            }
        })
        const phone3 = JSDB().getUser().first?.getJsonDesc("cphone3")
        let labelPhone3 = "טלפון 3";
        if (phone3) {
            labelPhone3 = phone3.name;

        }
        newCols.push({
            id: "phone3",
            label: labelPhone3,
            numeric: false,
            hide: true,
            priority: -1,
            editable: true,
            cellRenderer: ({params}) => {
                const openPhone = (result) => {
                    window.open(`tel:${result}`, '_blank')?.focus();
                };
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    >
                        {params?.data?.phone3 && <Typography variant="subtitle1" style={{cursor: "pointer"}}
                                                             onClick={() => openPhone(params?.data?.phone3)}>
                            <IconPhone size={12} strokeWidth={1} color='#000000'/> {params?.data?.phone3}
                        </Typography>}
                    </div>
                )
            }
        } )
            const notes2 = JSDB().getUser().first?.getJsonDesc("cnotes2")
            let labelNotes2 = "הערות לקוח 2";
            if (notes2) {
                labelNotes2 = notes2.name;


            }
            newCols.push(    {
                id: "notes2",
                label: labelNotes2,
                numeric: false,
                editable: true,
                type:'numOrStr',
                hide: true,
                priority: -1,

            })


            const notes3 = JSDB().getUser().first?.getJsonDesc("cnotes3")
            let labelNotes3 = "הערות לקוח 3";
            if (notes3) {
                labelNotes3 = notes3.name;


            }
            newCols.push(    {
                id: "notes3",
                label: labelNotes3,
                numeric: false,
                hide: true,
                type:'numOrStr',
                editable: true,
                priority: -1,
            })
            const notes4 = JSDB().getUser().first?.getJsonDesc("cnotes4")
            let labelNotes4 = "הערות לקוח 4";
            if (notes4) {
                labelNotes4 = notes4.name;


            }
        newCols.push(    {
            id: "notes4",
            label: labelNotes4,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes5 = JSDB().getUser().first?.getJsonDesc("cnotes5")
            let labelNotes5 = "הערות לקוח 5";
            if (notes5) {
                labelNotes5 = notes5.name;


            }
        newCols.push(    {
            id: "notes5",
            label: labelNotes5,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes6 = JSDB().getUser().first?.getJsonDesc("cnotes6")
            let labelNotes6 = "הערות לקוח 6";
            if (notes6) {
                labelNotes6 = notes6.name;


            }
        newCols.push(    {
            id: "notes6",
            label: labelNotes6,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes7 = JSDB().getUser().first?.getJsonDesc("cnotes7")
            let labelNotes7 = "הערות לקוח 7";
            if (notes7) {
                labelNotes7 = notes7.name;


            }
        newCols.push(    {
            id: "notes7",
            label: labelNotes7,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes8 = JSDB().getUser().first?.getJsonDesc("cnotes8")
            let labelNotes8 = "הערות לקוח 8";
            if (notes8) {
                labelNotes8 = notes8.name;


            }
        newCols.push(    {
            id: "notes8",
            label: labelNotes8,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes9 = JSDB().getUser().first?.getJsonDesc("cnotes9")
            let labelNotes9 = "הערות לקוח 9";
            if (notes9) {
                labelNotes9 = notes9.name;


            }
        newCols.push(    {
            id: "notes9",
            label: labelNotes9,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes10 = JSDB().getUser().first?.getJsonDesc("cnotes10")
            let labelNotes10 = "הערות לקוח 10";
            if (notes10) {
                labelNotes10 = notes10.name;


            }
        newCols.push(    {
            id: "notes10",
            label: labelNotes10,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes11 = JSDB().getUser().first?.getJsonDesc("cnotes11")
            let labelNotes11 = "הערות לקוח 11";
            if (notes11) {
                labelNotes11 = notes11.name;


            }
        newCols.push(    {
            id: "notes11",
            label: labelNotes11,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
        const notes12 = JSDB().getUser().first?.getJsonDesc("cnotes12")
            let labelNotes12 = "הערות לקוח 12";
            if (notes12) {
                labelNotes12 = notes12.name;


            }
        newCols.push(    {
            id: "notes12",
            label: labelNotes12,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })


        const paymentNotes = JSDB().getUser().first?.getJsonDesc("payment_notes")
        let paymentNotesLabel = "תנאי תשלום";
        if (paymentNotes) {
            paymentNotesLabel = paymentNotes.name;


        }
        newCols.push(    {
            id: "paymentComments",
            label: paymentNotesLabel,
            numeric: false,
            type:'numOrStr',
            editable: true,
            hide: true,
            priority: -1,

        })
            setCols(newCols)


    }, []);
    const handleNotActiveUsers = React.useCallback(() => {
        if (displayActive)
            setDisplayActive(false)
        else setDisplayActive(true)

    }, [displayActive]);

    const handleCreatePriceMenu = React.useCallback(async () => {
        const nextId = nextPriceMenuClientId(allCustomersForXlsx);
        const defaultAgent = agent.find((a) => a.active)?.name || agent[0]?.name || String(JSDB().currentAgent || '');
        if (!defaultAgent) {
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'אין קו/סוכן במערכת, לא ניתן להקים מחירון',
                variant: 'alert',
                alertSeverity: 'error',
            });
            return;
        }
        const result = await Swal.fire({
            title: 'הקמת מחירון',
            text: `ייווצר לקוח-מחירון עם מזהה ${nextId}`,
            input: 'text',
            inputLabel: 'שם מחירון',
            inputPlaceholder: 'שם המחירון',
            showCancelButton: true,
            confirmButtonText: 'צור',
            cancelButtonText: 'בטל',
            confirmButtonColor: theme?.palette?.primary?.dark,
            cancelButtonColor: theme?.palette?.error?.light,
            inputValidator: (value) => {
                if (!String(value || '').trim()) return 'נא להזין שם';
                return null;
            },
        });
        if (!result.isConfirmed) return;
        const name = String(result.value || '').trim();
        const user = JSDB().getUser()?.first;
        const submitted = makeCustomer({
            active: true,
            id: nextId as unknown as string,
            name,
            agent: defaultAgent,
            businessName: name,
            businessName2: name,
            externalId: '-1',
            withBarcode: user?.withBarcode?.() ?? false,
            withReturns: user?.withReturns?.() ?? false,
            withPrice: user?.withPrice?.() ?? false,
            includeTax: user?.includeTax?.() ?? false,
            notes: user?.notesOrTax?.() ?? true,
        });
        try {
            await (dispatch as any)(addCustomer(submitted)).unwrap();
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: `מחירון "${name}" נוצר בהצלחה (מזהה ${nextId})`,
                variant: 'alert',
                alertSeverity: 'success',
            });
        } catch (e: any) {
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: e?.message || 'שגיאה בהקמת מחירון',
                variant: 'alert',
                alertSeverity: 'error',
            });
        } finally {
            dispatch(initAddCustomerAsyncState());
        }
    }, [allCustomersForXlsx, agent, dispatch, theme]);


    const clientsImportAdapter = React.useMemo(() => buildClientsImportAdapter(dispatch), [dispatch]);
    React.useEffect(() => {
        dispatch(getCustomers());
        dispatch(getAgents());
    }, [dispatch]);

    const handleDrawerClose = React.useCallback(() => {
        setCustomerAction({
            editable: false,
            open: false,
            id: ''
        });
    }, []);

    // Add/Edit Customer drawer
    const [customerAction, setCustomerAction] = React.useState({
        editable: false,
        open: false,
        id: ''
    });

    const [new_clients, set_new_clients] = React.useState<boolean>(false);
    React.useEffect(() => {
        if (new_clients) {
            dispatch(getCustomersCreation())

        } else {
            dispatch(removeAllFilters())
        }
    }, [new_clients]);


    React.useEffect(() => {

        dispatch(removeAllFilters())
    }, [dispatch]);
    const [menuItems, setMenuItems] = React.useState<{
        agent?: {
            label: string,
            value: string
        }[],
        driver?: {
            label: string,
            value: string
        }[],
    }>({
        agent: [],
        driver: [],

    })

    React.useEffect(() => {
        if (menuItems?.agent?.length == 0 || menuItems?.driver?.length == 0)
            setMenuItems({
                driver: drivers.map((s) => {
                    return {
                        label: s.name,
                        value: s.name
                    }
                }),
                agent: agent.map((s) => {
                    return {
                        label: s.name,
                        value: s.name
                    }
                })
            })
    }, [agent, drivers]);

    const [previewOpen, setPreviewOpen] = React.useState(false);
    const [costumerDetails, setCostumerDetails] = React.useState({
        name: '',
        id: '',
    })
    const [openSendMessage, setOpenSendMessage] = React.useState(false);
    const [whatsAppDialog, setWhatsAppDialog] = React.useState<{open: boolean, rowData: any}>({open: false, rowData: null});
    const [clientEditLinkDialog, setClientEditLinkDialog] = React.useState<{open: boolean, rowData: any}>({
        open: false,
        rowData: null,
    });
    const [chooseBranch, setChooseBranch] = React.useState(false);
    const [branches, setBranches] = React.useState<string[]>([]);

    // Build network list from ALL customers (active + inactive). Using the filtered
    // display list caused duplicate network ids when creating a network while inactive
    // customers already held higher branch ids.
    React.useEffect(() => {
        const branchesSet: any = [];
        allCustomersForXlsx.forEach((c) => {
            if (c?.nkObject?.branch >= 0) {
                // Always the master's identity: in מפוצל עם ח.פ עצמאי each member carries its own
                // שם עוסק, and naming the network after the member would list it once per branch.
                const name = c?.nkObject?.getNetworkBusinessName?.() ?? c?.businessName;
                if (branchesSet.find((s) => s.name == name && s.branch == c.nkObject.branch)) {
                    return;
                }
                let master = c.nkObject.master
                if (!master || master == -1)
                    master = c.id
                branchesSet.push({
                    name: name,
                    id: c?.nkObject?.getNetworkBusinessId?.() ?? c?.businessId,
                    branch: c.nkObject.branch,
                    master: master,
                });
            }
        });
        setBranches(branchesSet);
    }, [allCustomersForXlsx]);

    const chipDetails = React.useMemo(() => {
        return [
            {
                action: (params, originalTableState) => {
                    const isGrouped = customGroupActiveForChip(params, ["branch"])
                    const allColumns = params.columnApi.getColumns();
                    const colsToDislay = [
                        "id",
                        "branch",
                        "name",
                        'edi_sup_id',
                        'edi_client_id',
                        'net_edi',
                        'branch_number',
                        'internal_sup_edi',
                    ];
                    const colsToHide = [
                        'edi_sup_id',
                        'edi_client_id',
                        'net_edi',
                        'branch_number',
                        'internal_sup_edi',
                    ]
                    if (!isGrouped) {
                        setColumnState(params?.columnApi?.getColumnState())
                        params?.columnApi?.applyColumnState({
                            state: allColumns.map((col) => {
                                if (col.colDef.id === "branch") {
                                    return {colId: col.colId, hide: false, rowGroup: true}
                                }
                                if (colsToDislay.includes(col.colDef.id)) {
                                    return {colId: col.colId, hide: false}
                                } else {
                                    return {colId: col.colId, hide: true}
                                }
                            }),
                            applyOrder: true,
                        });
                    } else {

                        params?.columnApi?.applyColumnState({
                            state: state ?? allColumns.map((col) => {
                                if (col.colDef.id === "branch") {
                                    return {colId: col.colId, hide: false, rowGroup: false}
                                }
                                if (colsToHide.includes(col.colDef.id) || col?.colDef?.hide) {
                                    return {colId: col.colId, hide: true}
                                } else {
                                    return {colId: col.colId, hide: false}
                                }
                            }),
                            applyOrder: true,
                        });
                    }
                },
                label: (params) => customGroupLabelForChip(params, ["branch"], "קבץ לפי רשתות", "הסר קיבוץ לפי רשתות"),
                icon: <PeopleIcon/>,
                tooltip: "קבץ את העמודות לפי רשתות",
                active: (params) => customGroupActiveForChip(params, ["branch"]),
            },
            {
                action: (params, originalTableState) => customGroup(params, ["agent"]),
                label: (params) => customGroupLabelForChip(params, ["agent"], "קבץ לפי קווים", "הסר קיבוץ לפי קווים"),
                icon: <IconInfoCircle/>,
                tooltip: "קבץ את העמודות לפי קווים ",
                active: (params) => customGroupActiveForChip(params, ["agent"]),
            },
            {
                action: (params, originalTableState) => customGroup(params, ["driver"]),
                label: (params) => customGroupLabelForChip(params, ["driver"], "קבץ לפי נהגים", "הסר קיבוץ לפי נהגים"),
                icon: <IconInfoCircle/>,
                tooltip: "קבץ את העמודות לפי נהגים ",
                active: (params) => customGroupActiveForChip(params, ["driver"]),
            },
            {
                action: (params, originalTableState) => customGroup(params, ["city"]),
                label: (params) => customGroupLabelForChip(params, ["city"], "קבץ לפי ערים", "הסר קיבוץ לפי ערים"),
                icon: <IconInfoCircle/>,
                tooltip: "קבץ את העמודות לפי ערים ",
                active: (params) => customGroupActiveForChip(params, ["city"]),
            },
            // {
            //     icon: <CloudUploadIcon />,
            //     tooltip: "העלה קובץ",
            //     action: () => {
            //         const button = document.getElementById("upload-file-dialog-button");
            //         if (button) {
            //             button.click();
            //         }
            //     },
            //     label: () => {
            //         return "העלה קובץ"
            //     },
            //     active: () => false
            // },
            {
                action: (params) => {
                    const allCols = params?.columnApi?.getColumns();
                    const createDateCol = allCols?.find((col) => col?.colDef?.id === "date");
                    if (createDateCol?.visible) {
                        set_new_clients(false)
                        params?.columnApi?.setColumnVisible(createDateCol?.colId, false)
                    } else {
                        set_new_clients(true)
                        params?.columnApi?.setColumnVisible(createDateCol?.colId, true)
                    }
                },
                label: (params) => params?.columnApi?.getColumns()?.find((col) => col?.colDef?.id === "date")?.visible ? "הסתר תאריך יצירה" : "הצג תאריך יצירה",
                icon: <IconInfoCircle/>,
                tooltip: "הצג תאריך יצירה",
                active: (params) => params?.columnApi?.getColumns()?.find((col) => col?.colDef?.id === "date")?.visible
            },
        ]
    }, []);

    const selectionChips = React.useCallback((selectedItems) => {
        return (
            <>
                <Tooltip title='שלח מחירונים באימייל' onClick={(a) => {
                    // callback
                }}
                >
                    <Chip
                        icon={<EmailOutlined/>} sx={{
                        ml: 0.5, mr: 0.5, '& .MuiChip-icon': {
                            color: '#000080',
                        },
                    }} label={"שלח מחירונים באימייל"} variant="outlined"/>
                </Tooltip>
                <Tooltip title='שלח מחירונים בוואטסאפ' onClick={(a) => {
                    // callback
                }}
                >
                    <Chip
                        icon={<WhatsApp/>} sx={{
                        ml: 0.5, mr: 0.5, '& .MuiChip-icon': {
                            color: '#000080',
                        },
                    }} label={"שלח מחירונים בוואטסאפ"} variant="outlined"/>
                </Tooltip>
            </>
        )
    }, []);

    const saveDataCallback = React.useCallback(async (data) => {
        try {
            const capped = Array.isArray(data)
                ? data.map((row) => {
                    const n = Number(row?.discount);
                    if (Number.isFinite(n) && n > 100) return {...row, discount: 100};
                    return row;
                })
                : data;
            const x = await changeAllCustomers(capped)
            dispatch(fillCustomers());

            return true
        } catch (e) {
            console.log(e)
            return false
        }

    }, [changeAllCustomers, dispatch])

    const callCustomerFetch = React.useCallback(async (setLoader) => {
        setLoader(true)
        try {
            fetchMimshakClient(new Date(),()=>{
                dispatch(getCustomers());
            })


            return true
        } catch (e) {
            console.log(e)
            return false
        }
        setLoader(false)

    }, [changeAllCustomers, dispatch])

    const addDataAction = React.useMemo(() => {
        return {
            tooltip: "הוסף לקוח",
            label: "הוסף לקוח",
            action: () => {
                setCustomerAction({editable: false, open: true, id: ''})
            }
        }
    }, [])

    const rightClickActions = React.useMemo(() => {
        return {
            branch: {
                name: "בחר/ צור רשת",
                action: () => {
                    setChooseBranch(true);
                },
            },
            name: {
                name: "בחר/ צור רשת",
                action: () => {
                    setChooseBranch(true);
                },
            }, businessName: {
                name: "בחר/ צור רשת",
                action: () => {
                    setChooseBranch(true);
                },
            }
        }
    }, []);

    const specialDialogs = React.useCallback((params) => {
        return <CreateBranchDialog
            chooseBranch={chooseBranch}
            setChooseBranch={setChooseBranch}
            branches={branches}
            params={params}
        />
    }, [chooseBranch, branches])

    const [selectedCustomers, setSelectedCustomers] = React.useState<any[]>([])
    React.useEffect(() => {
        if (!openSendMessage) {
            setSelectedCustomers([])
        }
    }, [openSendMessage])
    const contextMenu = React.useCallback((params) => {

        const ranges = params?.api?.getCellRanges();

        const selected = getSelectedRows(params?.api)
        let nodesInRange: any = [];
        selected?.forEach((row) => {
            nodesInRange.push(row);
        })
        if (!selected?.length) {
            ranges?.forEach((range) => {
                const rowMin = range?.startRow?.rowIndex < range?.endRow?.rowIndex ? range?.startRow?.rowIndex : range?.endRow?.rowIndex;
                const rowMax = range?.startRow?.rowIndex > range?.endRow?.rowIndex ? range?.startRow?.rowIndex : range?.endRow?.rowIndex;
                for (let i = rowMin; i <= rowMax; i += 1) {
                    const node = params.api?.getDisplayedRowAtIndex(i);
                    if (node?.data) {
                        nodesInRange.push(node?.data)
                    }
                }
            })
        }
        nodesInRange = distinctByField(nodesInRange, "id")
        setSelectedCustomers(nodesInRange.map((item: any) => item?.id))

        const items: { name: string; action: () => void }[] = [
            {
                name: "שלח הודעה",
                action: () => {
                    setOpenSendMessage(true)
                }
            }
        ];
        if (getRepLinkFlags().clientSignup && nodesInRange.length === 1 && nodesInRange[0]?.id) {
            items.push({
                name: "לינק עדכון פרטים / חתימה על מסמכים",
                action: () => {
                    setClientEditLinkDialog({open: true, rowData: nodesInRange[0]});
                },
            });
        }
        return items;
    }, [chooseBranch])

    const tableControls: ITableControls = React.useMemo(() => ({
        tableName: 'customers/customers-list',
        sidebar: true,
        localisation: true,
        groupBy: {
            enable: true,
            rowGroup: true,
            pivot: true,
            value: true,
        },
        selection: {
            enable: true,
            mode: "multiple"
        },
        extractId: (row) => row?.data?.id,
        cellRenderer: (params, column, i) => {

            if (column.cellRenderer) {
                return column.cellRenderer({
                    params,
                    column,
                    i,
                    setCostumerDetails,
                    setPreviewOpen,
                    setCustomerAction,
                    theme,
                    dispatch,
                    menuItems,
                    priceMenus,
                    setWhatsAppDialog,
                })
            }


            if (column.label === "תאריך יצירה" || column.id === "date") {
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    >
                        {params?.data?.date && <Typography variant="subtitle1">
                            {dayjs(params?.data?.date)?.format('DD/MM/YYYY')}
                        </Typography>}
                    </div>
                )
            }
            if (typeof params?.value === "object") {
                const value = params?.value?.value || "";
                return value;
            }
            return params?.value || '';
        },
        sideBarActions: [
            {
                buttonLabel: "הצג פרטי לקוח",
                displayList: [
                    'שם לקוח',
                    'פרטי עסק',
                    'טלפון',
                    'טלפון 2',
                    'מייל'
                ]
            }
        ],
    }), [theme, dispatch, menuItems, priceMenus])

    return (
        <>
            {asyncState === 'loading' && <Loader/>}

            <AgTableContainer controls={React.useCallback(() => {
                return (
                    <Box style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "start",
                        position: "relative",
                        height: "100%",
                        alignItems: "center"
                    }}>
                        <div style={{
                            position: "absolute",
                            left: "0",
                            top: "0",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                        }}>
                            <Chip
                                label={displayActive ? "הצג לקוחות לא פעילים" : "הצג לקוחות פעילים"}
                                icon={<User style={{
                                    color: displayActive ? "red" : "blue",
                                }}/>}
                                onClick={handleNotActiveUsers}
                                variant="outlined"
                                style={{
                                    color: displayActive ? "red" : "blue",
                                    borderColor: displayActive ? "red" : "blue",
                                }}
                            />
                            <Chip
                                label="הקמת מחירון"
                                icon={<PriceChangeOutlined style={{color: '#2e7d32'}}/>}
                                onClick={handleCreatePriceMenu}
                                variant="outlined"
                                style={{
                                    marginRight: 8,
                                    color: '#2e7d32',
                                    borderColor: '#2e7d32',
                                }}
                            />
                            <Tooltip title={'משיכת לקוחות מממשק'}>

                                <GenerativeLoaderChip labelText={'משיכת לקוחות מממשק'} func={callCustomerFetch} icon={<PeopleIcon sx={{width: '24px', height: '24px', mr: 0, ml: 0, p: 0}}/>}/>

                            </Tooltip>

                            <ImportWizardTrigger
                                chipLabel='טעינת לקוחות מאקסל'
                                adapter={clientsImportAdapter}
                                currentData={allCustomersXlsxRef.current}
                                onFinished={() => dispatch(getCustomers())}
                            />

                        </div>
                    </Box>
                )
            }, [displayActive, handleNotActiveUsers, handleCreatePriceMenu, callCustomerFetch])} tableName={
                <div>
                    <span>
                        רשימת לקוחות {" "}
                    </span>
                    <span style={{
                        color: displayActive ? "blue" : "red",
                    }}>
                        {
                            displayActive ? "פעילים" : "לא פעילים"
                        }
                    </span>
                </div>
            }>
                <AgTable
                    columns={cols}
                    data={customers}
                    tableControls={tableControls}
                    chipDetails={chipDetails}
                    saveDataCallback={saveDataCallback}
                    menuiItems={menuItems}
                    addDataAction={addDataAction}
                    rightClickActions={rightClickActions}
                    specialDialogs={specialDialogs}
                    selectionControls={selectionChips}
                    extentedContextMenu={contextMenu}
                />
            </AgTableContainer>
            {customerAction.open ? <AddCustomer
                open={customerAction.open}
                handleDrawerOpen={handleDrawerClose}
                id={customerAction.id}
                editable={customerAction.editable}
                setPreviewOpen={setPreviewOpen}
                branches={branches}
            /> : undefined}
            {previewOpen ? <Dialog TransitionComponent={Transition} fullScreen fullWidth open={previewOpen}
                                   onBackdropClick={() => {
                                       setPreviewOpen(false)
                                       setCostumerDetails({
                                           id: "",
                                           name: ""
                                       })
                                   }}
                                   sx={{'& .MuiDialog-paper': {p: 0}}}>
                <AppBar sx={{position: 'sticky'}}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => {
                                setPreviewOpen(false)
                                setCostumerDetails({
                                    id: "",
                                    name: ""
                                })
                            }}
                            aria-label="close"
                        >
                            <CloseIcon/>
                        </IconButton>
                        <Typography sx={{ml: 2, flex: 1, color: 'white'}} variant="h6" component="div">
                            סגור חלון
                        </Typography>
                        <Typography onClick={() => {
                            setPreviewOpen(false)
                            setCostumerDetails({
                                id: "",
                                name: ""
                            })
                        }}>
                            {costumerDetails?.name}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <CustomerPreview id={costumerDetails?.id}/>
            </Dialog> : undefined}
            {openSendMessage ? <SendMessageDialog
                open={openSendMessage}
                setOpen={setOpenSendMessage}
                toSelected={selectedCustomers}
                withFiles={false}
            /> : undefined}
            <WhatsAppLinkDialog
                open={whatsAppDialog.open}
                rowData={whatsAppDialog.rowData}
                onClose={() => setWhatsAppDialog({open: false, rowData: null})}
            />
            <ClientEditLinkDialog
                open={clientEditLinkDialog.open}
                rowData={clientEditLinkDialog.rowData}
                onClose={() => setClientEditLinkDialog({open: false, rowData: null})}
            />

        </>
    );
};

export default CustomerList;
